module.exports = __webpack_public_path__ + "static/media/marker-grey.632b89b7.svg";